export default {
  title:'ドキドキニケ 人気Top1 コスチューム投票',
  time:'2023/06/29 12:00-2023/07/05 23:59 (UTC+9)',
  curp:'現在の人気値',
  bottips:'人気値の合計は毎日18:00(UTC+9)に更新されます。',
  toptips:'コスチュームのデザインは開発中<br>のイメージ図です、完成版と異なる場合がございます。',
  dvotet:'投票するプランをご確認ください。',
  dvotep:'「OK」をタップすると、変更できなくなります。',
  cancel:'取消',
  confirm:'O K',
  dloginp:'コスチューム投票を行い、ゲームにアクセスすると、<strong>募集チケット1枚</strong>を獲得できます。',
  username:'メールアドレス',
  password:'パスワード',
  login:'ログイン',
  register:'ダウンロード＆アカウント登録',
  logintips:'*ゲームからアカウントを作成してください',
  forgetPassword:'パスワードを忘れた場合',
  logint:'あなたのニックネームをご<br>確認ください',
  server:'サーバー',
  nickname:'ニックネーム',
  logintip2:'*各アカウントにつき1人のキャラクターのみ投票を行い、報酬を獲得できます。',
  rulet:'ルール',
  rp1:'イベント説明<br>イベント期間：2023/06/29 12:00 (UTC+9)～2023/07/05 23:59 (UTC+9)<br>イベント期間中、好きなモダニアのコスチュームプランに投票できます。イベント終了後、投票数の最も多いコスチュームを作成し、無料で指揮官全員に配布いたします！<br>※配布日については引き続き公式のお知らせをお待ちください。',
  rp2:'イベント参加についての説明<br>イベント期間中、好きなコスチュームに1回投票できます。一度投票すると変更はできません。',
  rp3:'ゲーム報酬<br>1.投票すると、募集チケットを1枚獲得できます。チケットの受け取りは1回のみです。ゲーム内の受信箱からお受け取りください。<br>2.指定されたコミュニティでシェアすると、募集チケットを1枚獲得できます。チケットの受け取りは初回の1回のみです。ゲーム内の受信箱からお受け取りください。',
  rp4:'ご利用上の注意<br>1.コスチュームの画像はあくまでも開発中のイメージ図であり、最終的なイメージとポーズではありません。<br>2.ゲームにログインしてイベントにご参加ください。アカウント毎に１つのサーバーにつき1つのニックネームのみ連携ができます、複数の連携はできませんのでご注意ください。<br>3.ページ上の投票データは毎日18:00（UTC+9）に更新されます。最終的な投票結果は7月6日18:00(UTC+9)にこのページで発表されます。<br>4.イベント参加により獲得したゲーム内の報酬は受信箱に配布されます。報酬の配布はシステム上の理由により、若干遅れる場合がございます。予めご了承ください。メールの有効期間は30日です。適時、お受け取り下さい。',
  rp5:'最終的な投票結果は7月6日18:00(UTC+9)にこのページで発表されます。',
  votebtn:'投票',
  surepara:'投票ポータルにアクセスすると、ログイン資格情報、ユーザー ID、サーバー情報、ニックネーム、および投票データ (参加データ) が収集されます。投票リンクから個人情報を収集することはなく、データは統計に記録されます。集計・参加データはシンガポールのサーバーに 6 か月間保存され、その後削除されます。当社の個人情報の取り扱い方法の詳細については、当社の<a href="https://nikke-jp.com/privacypolicy" target="blank" class="dicon5" title="">【プライバシー ポリシー】</a>をご参照ください。',
  plan1:'-プランA-',
  plan2:'-プランB-',
  plan3:'-プランC-',

  account_not_exist: 'アカウントが存在しません。ゲーム内でアカウントを登録してください。',
  password_empty: 'パスワードを入力してください',
  pleaseLogIn: '先にログイン',
  password_not_set: 'アカウントのパスワードは設定していません',

  shareContentBet: `どきどきっ！私の投票結果予想
  間もなく、NIKKE グローバル人気投票第二回が始まります。TOP5にランクインするニケを予想しましょう。
  #votefornikke2024
  #NIKKE第2回人気投票
  #nikke
  #ニケ
  #NIKKEAnniversary
  `,
  shareContentVote: `どきどき！私のNIKKEチョイス
  NIKKE グローバル人気投票 第二回開催中！今すぐ大好きなニケに投票しましょう。
  #votefornikke2024
  #NIKKE第2回人気投票
  #nikke
  #ニケ
  #NIKKEAnniversary`,
  shareContentSpecial: `私のスペシャル投票チョイス
  NIKKEグローバル人気投票第2回開催中！投票に参加してゲーム内特典を手に入れましょう！
  #votefornikke2024
  #NIKKE第2回人気投票
  #nikke
  #ニケ
  #NIKKEAnniversary`,
  shareContentTop: `NIKKE グローバル人気投票 第二回開催中！今すぐ大好きなニケに投票しましょう。
  #votefornikke2024
  #NIKKE第2回人気投票
  #nikke
  #ニケ
  #NIKKEAnniversary`,

  BaseSystemError: '投票システムエラー',
  VoteDelNumNotEnough: '投票回数が足りません',
  RoleInfoNotSaved: 'キャラ情報が保存されていません',
  NoRoleInfo: 'キャラ情報が見つかりません',
  RoleInfoHasSaved: 'キャラ情報の保存が完了しました',
  FlowHasNotBegin: 'イベント期間外です',
  FlowHasEnd: 'イベント終了',
  SignedDayNotEnough: '本日分の解放は完了しました。明日もう一度お試しください',
  HasSignedToday: '本日はログイン済みです',
  GetGiftLimit: 'パックの受取制限に達しました',
  MiddlewareFlowLock: '再読み込みが早すぎます。しばらくしてから再度お試しください',
  third_auth_failed: '第三者アカウントでのログインに失敗しました再度、お試しください。',
  pls_input_info: 'ログイン情報を入力してください。',
  serverError: 'サーバーエラー',
  networkError: 'ネットワークエラー',
  GetRoleInfoAccountTypeErr: 'アカウントタイプエラー',
  please_select: '選択してください',
  submitted_vote: '投票を提出しました。再投票できません。',
  share_failed: 'シェア失敗',
  no_role_found: 'キャラデータが見つかりませんでした',
  laodingPic: '画像生成中…',
  loading: 'ロード中…',
  nv_vote_p: '投票で選ばれた人気No.1のコスチュームを、全指揮官様に無料でプレゼント！',
  open_in_browser: '他のブラウザーでお試しください',
  logout: 'ログアウト',
  privacy:'プライバシーポリシー',
  cookies:'クッキーズポリシー',
  privacyLink:'https://nikke-jp.com/privacypolicy/',
  cookiesLink:'https://nikke-jp.com/cookiepolicy/',

  claimable: '受取可能',
  claimed: '受領済',
  claimSucess: '受取成功',

  elysion: 'エリシオン',
  pilgrim: 'ピルグリム',
  tetra: 'テトラ',
  missilis: 'ミシリス',

  specialVoteNotEnough:'本日はすでに投票が完了してます',
  hasBet:'すでに予想は完了してます',
  hasVote:'本日はすでに投票が完了してます',
  requestFast:'リクエストが多すぎます、時間を置いてから再度お試しください',
};
